import {useEffect, useState} from "react";
import {TextField} from "@material-ui/core";
import {Button, Form} from "react-bootstrap";
import Message from "../message";

function Company_website() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

    const [website_col_name, setWebsite_col_name] = useState("");
    const [website, setWebsite] = useState("");
    const [status_website, setStatus_website] = useState("");
    const [status_serp_creds, setStatus_serp_creds] = useState("fetching...");

    useEffect(async () => {
        const creds_remaining = await fetch(
            apiServer + "api/helper/value_serp_account"
        );
        setStatus_serp_creds(await creds_remaining.json());
    }, []);

    const sumbit_company_website = async () => {
        setStatus_website("");

        if (website.length <= 0) {
            setStatus_website("Upload some files!");
        } else if (website_col_name === "") {
            setStatus_website("Fill column name!");
        } else {
            const website_formData = new FormData();
            website_formData.set("file", website);

            const requestOptions = {
                method: "POST",
                body: website_formData,
            };

            try {
                const gst_response = await fetch(
                    apiServer +
                    `api/company_website/upload_file?col_name=${website_col_name}`,
                    requestOptions
                );
                const gst_status_id = await gst_response.json();
                const gst_status = gst_status_id.detail
                    ? gst_status_id.detail
                    : gst_status_id;

                setStatus_website(gst_status);
            } catch (e) {
                console.log(e);
            }
        }
    };

    return (
        <div style={{marginTop: "2px"}}>
            <p>
                Credits remaining : <strong>{status_serp_creds}</strong>
            </p>
            <TextField
                style={{marginBottom: "15px", width: "100%", marginTop: "5px"}}
                value={website_col_name}
                onChange={(e) => setWebsite_col_name(e.target.value)}
                id="outlined-basic"
                label="Column name"
                variant="filled"
            />
            <Form.Control
                type="file"
                onChange={(e) => setWebsite(e.target.files[0])}
            />
            <Button
                variant="primary"
                style={{marginTop: "20px", width: "100%"}}
                onClick={() => sumbit_company_website()}
            >
                Submit
            </Button>
            {Message(status_website, setStatus_website)}
        </div>
    );
}

export default Company_website;
